/*
 * For each Judge.me review card inside the home-page section
 * identified by id suffix `__1766379091379b49cf`, render a clickable
 * product tile (image + name) below the card linking to the product.
 *
 * We hide the in-card product info via CSS and fetch the product
 * image from Shopify's product JSON by handle.
 */
(function () {
  var SECTION_SELECTOR = '[id$="__1766379091379b49cf"]';
  var TILE_CLASS = 'mp-review-product-tile';
  var TILE_FLAG = 'data-mp-tile-mounted';

  var CARD_SELECTORS = [
    '.jdgm-carousel-item',
    '.jdgm-carousel-card',
    '.jdgm-rev',
    '.jdgm-rev-widg__review'
  ].join(',');

  var LINK_SELECTORS = [
    '.jdgm-carousel-item__product-link',
    '.jdgm-carousel-item__title a',
    '.jdgm-carousel-item__product a',
    '.jdgm-rev__product-link',
    '.jdgm-rev__product a',
    '.jdgm-rev__pic-link',
    'a[href*="/products/"]'
  ].join(',');

  var productCache = Object.create(null);

  function getProductHandle(href) {
    try {
      var url = new URL(href, window.location.origin);
      var m = url.pathname.match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    } catch (e) { return null; }
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  function imageUrl(url, size) {
    if (!url) return '';
    return url.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?|$)/i, '_' + size + '$1$2');
  }

  function hideAppProductInfo(card, harvestedLink) {
    // Hide every product link the app rendered inside this card (other
    // than our own tile), plus any container that obviously holds the
    // product info or product title text.
    var links = card.querySelectorAll('a[href*="/products/"]');
    links.forEach(function (a) {
      if (a.closest('.' + TILE_CLASS)) return;
      a.style.display = 'none';
      // Walk up a couple of levels to hide wrapping product-info blocks.
      var up = a.parentElement;
      for (var i = 0; i < 2 && up && up !== card; i++) {
        var cls = (up.className || '').toString().toLowerCase();
        if (/product|title|info|name/.test(cls)) {
          up.style.display = 'none';
          break;
        }
        up = up.parentElement;
      }
    });
  }

  function mountTile(card) {
    if (card.hasAttribute(TILE_FLAG)) return false;

    var link = card.querySelector(LINK_SELECTORS);
    if (!link) return false;
    var href = link.getAttribute('href');
    if (!href) return false;
    var handle = getProductHandle(href);
    if (!handle) return false;

    card.setAttribute(TILE_FLAG, '1');

    var name = (link.textContent || '').trim() || handle.replace(/-/g, ' ');

    // Remove the app's product info from inside the card now that we've
    // harvested it — we render our own tile below.
    hideAppProductInfo(card, link);

    var tile = document.createElement('a');
    tile.className = TILE_CLASS;
    tile.href = href;
    tile.innerHTML =
      '<div class="' + TILE_CLASS + '__img-wrap"><img class="' + TILE_CLASS + '__img" alt="" loading="lazy"></div>' +
      '<span class="' + TILE_CLASS + '__name">' + escapeHtml(name) + '</span>';

    card.appendChild(tile);

    fetchProduct(handle).then(function (product) {
      if (!product) return;
      var img = tile.querySelector('img');
      var raw = product.featured_image || (product.images && product.images[0]) || '';
      if (raw) img.src = imageUrl(raw, '300x300');
      var nameEl = tile.querySelector('.' + TILE_CLASS + '__name');
      if (product.title) nameEl.textContent = product.title;
    });
    return true;
  }

  // Accessibility: Judge.me's carousel keeps cloned cards (for the infinite
  // loop) and off-screen cards with aria-hidden="true" while their links stay
  // focusable, which fails the "ARIA hidden element must not contain
  // focusable elements" audit. `inert` removes them from the tab order and
  // the accessibility tree for as long as they are hidden; it is lifted again
  // when the app un-hides a card.
  var CLONE_SELECTORS = '.jdgm-clone-before, .jdgm-clone-after';
  function syncInert(section) {
    var cards = section.querySelectorAll(CARD_SELECTORS);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var hidden = card.getAttribute('aria-hidden') === 'true' || card.matches(CLONE_SELECTORS);
      if (hidden) {
        if (!card.hasAttribute('inert')) card.setAttribute('inert', '');
      } else if (card.hasAttribute('inert')) {
        card.removeAttribute('inert');
      }
    }
  }

  function scan(section) {
    var cards = section.querySelectorAll(CARD_SELECTORS);
    var added = 0;
    for (var i = 0; i < cards.length; i++) {
      if (mountTile(cards[i])) added++;
    }
    syncInert(section);
    return added > 0;
  }

  function init() {
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    scan(section);

    // Judge.me renders/refreshes asynchronously — re-scan on subtree changes.
    var debounceTimer = null;
    var observer = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { scan(section); }, 80);
    });
    observer.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'class'] });

    // Stop mounting tiles after a generous window, but keep following the
    // carousel's aria-hidden changes so `inert` always matches them.
    setTimeout(function () {
      observer.disconnect();
      var hiddenObserver = new MutationObserver(function () { syncInert(section); });
      hiddenObserver.observe(section, { subtree: true, attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
